import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const addTeamMember = async (teamId: string, workerId: string, callback: CallbackObject<any>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res: AxiosResponse = await instance.post(`/management/teams/${teamId}/members/${workerId}`, {}, config);
        callback.success(res.data);
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
